import { render, staticRenderFns } from "./PwChangeDone.vue?vue&type=template&id=04f4a860&scoped=true"
import script from "./PwChangeDone.vue?vue&type=script&lang=js"
export * from "./PwChangeDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4a860",
  null
  
)

export default component.exports